import { create } from "zustand";

import { ScreenType } from "./models/globalStoreModel";

type State = {
  isDesktop: boolean;
  screenType: ScreenType;
  IsTabletReal: boolean;
  isCloseMenuAccountMobile: boolean;
  isAutoOpenCalendar: boolean;
};

type Actions = {
  setIsDesktop: (trigger: boolean) => void;
  setScreenType: (screenType: ScreenType) => void;
  setIsTabletReal: (trigger: boolean) => void;
  setIsCloseMenuAccountMobile: (trigger: boolean) => void;
  setIsAutoOpenCalendar: (state: boolean) => void;
};

export const useGlobalStore = create<State & Actions>((set) => ({
  isDesktop: true,
  screenType: ScreenType.DESKTOP,
  IsTabletReal: false,
  isAutoOpenCalendar: false,
  isCloseMenuAccountMobile: false,
  setIsAutoOpenCalendar: (state: boolean) =>
    set(() => ({ isAutoOpenCalendar: state })),
  setIsDesktop: (trigger: boolean) => set(() => ({ isDesktop: trigger })),
  setScreenType: (screenType: ScreenType) => set(() => ({ screenType })),
  setIsTabletReal: (trigger: boolean) => set(() => ({ IsTabletReal: trigger })),
  setIsCloseMenuAccountMobile: (trigger: boolean) =>
    set(() => ({ isCloseMenuAccountMobile: trigger })),
}));
